import { Component } from '@angular/core';
import { USEFUL_LINKS } from '@shared/consts/useful-links.consts';
import { IUsefulLinks } from '@shared/models/main.interfaces';
@Component({
    selector: 'anp-links',
    templateUrl: './links.component.html',
    styleUrls: ['./links.component.scss'],
    standalone: false
})
export class LinksComponent {
  public usefulLinks: IUsefulLinks[] =[];

  constructor() {
    this.usefulLinks = USEFUL_LINKS
  }

}
